import React, { useEffect, useState } from 'react'
import { Select } from 'components/common/Select'
import { POST_CODES } from '@wellbeingxltd/fe-lib/constants'
import { Autocomplete, TextField } from '@mui/material'

const PostCode = ({ selectedCode, setSelectedCode, setChecked, checked }) => {
    const [postCodes, setPostCodes] = useState([])
    const [value, setValue] = useState('')

    useEffect(() => {
        setPostCodes([...new Set(POST_CODES)].map(code => ({ value: code, label: code })))
    }, [])

    useEffect(() => {
        if (selectedCode) {
            setValue(postCodes.find(el => el.value === selectedCode))
        } else {
            setValue('')
        }
    }, [selectedCode, postCodes])
    return (
        <div>
            <p
                style={{
                    fontWeight: '700',
                    paddingBottom: 12,
                }}
            >
                Near which postcode would you like to see in-person resources?
            </p>
            <Autocomplete
                disablePortal
                id="postCode"
                style={{
                    border: 'none',
                    borderRadius: 0,
                    backgroundColor: 'transparent',
                    marginBottom: 16,
                }}
                options={postCodes}
                onChange={(_, newValue) => {
                    setSelectedCode(newValue.value)
                    setChecked(false)
                }}
                value={value}
                onSelect={() => setChecked(false)}
                renderInput={params => (
                    <TextField
                        {...params}
                        placeholder={!selectedCode ? 'e.g. SW20' : ''}
                        inputProps={{ ...params.inputProps, style: { fontSize: 16 } }}
                    />
                )}
            />
        </div>
    )
}

export default PostCode
